import { environment } from '../../../../environments/environment'
import { type CartoClient } from './carto.helper'

export interface StreetRow {
  id: string
  name: string
  geom: string
  nvisitors: number
}

export interface StreetsFilters {
  delivery_id: number
  filter_combined: string
}

export async function fetchStreets(
  cartoClient: CartoClient,
  filters: StreetsFilters,
  signal?: AbortSignal,
) {
  const { delivery_id, filter_combined } = filters

  const response = await cartoClient.query<StreetRow>({
    source: {
      source: `${environment.CARTO_SOURCE_PREFIX}_streets_params`,
      queryParameters: {
        delivery_id,
        filter_combined,
      },
    },
    params: {
      column: ['id', 'name', 'geom', 'nvisitors'],
    },
    signal,
  })

  const rows = response?.rows ?? []

  return {
    type: 'FeatureCollection' as const,
    features: rows.map((row) => ({
      type: 'Feature' as const,
      properties: {
        cartodb_id: row.id,
        nvisitors: row.nvisitors,
      },
      geometry: row.geom,
    })),
  }
}
